import React, {useEffect, useRef, useState} from 'react';
import FormInput from "../../formComponents/FormInput";
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import FormCheckbox from "../../formComponents/FormCheckbox";
import FormLinkedItemSelect from "../../formComponents/FormLinkedItemSelect";

const CitiesItemForm = ({initData, controlRef}) => {

    const controlRefName = useRef(null);
    const controlRefCountry = useRef(null);
    const controlRefRegion = useRef(null);

    const [selectedCountryId, setSelectedCountryId] = useState(getInitialCountryId(initData));
    const [selectedRegionId, setSelectedRegionId] = useState(initData?.region_id ?? undefined)
    const [isRegionCity, setIsRegionCity] = useState(initData?.is_region_city ?? false);

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                getData: getData,
            };
        }
    });

    function validate() {
        let isValid = true;

        if (!controlRefName.current.validateNotEmpty("Нужно указать название!"))
            isValid = false;

        if (!controlRefName.current.validateLength(255))
            isValid = false;

        if (!controlRefCountry.current.validateIsSelected("Нужно выбрать страну!"))
            isValid = false;

        if (!isRegionCity && selectedCountryId && !controlRefRegion.current.validateIsSelected("Нужно выбрать регион!"))
            isValid = false;

        return isValid;
    }

    function getData() {
        return {
            name: controlRefName.current.getText(),
            is_region_city: isRegionCity,
            country_id: isRegionCity ? selectedCountryId : null,
            region_id: isRegionCity ? null : selectedRegionId,
            is_hidden: isRegionCity ? (initData?.is_hidden ?? false) : false,
        }
    }

    return (
        <BaseSimpleItemEditorForm>
            <FormBlock title="Основные">
                <FormInput
                    controlRef={controlRefName}
                    label="Название"
                    widthLimit={350}
                    initValue={initData?.name ?? ""}
                />
                <FormLinkedItemSelect
                    controlRef={controlRefCountry}
                    label="Страна"
                    widthLimit={450}
                    initSelectedId={getInitialCountryId(initData)}
                    initRefList={initData?.refs?.countries}
                    apiName2="countries"
                    showIds={true}
                    onSelect={selectedId => {
                        setSelectedCountryId(selectedId);
                        setSelectedRegionId(undefined);
                    }}
                />
                <FormCheckbox
                    controlRef={null}
                    label="Город-регион"
                    initValue={initData?.is_region_city ?? false}
                    onSelect={value => setIsRegionCity(value)}
                    tipText={"Поставьте галку, если город является самостоятельным регионом (например, Москва)"}
                />
                {!isRegionCity && <FormLinkedItemSelect
                    locked={!Boolean(selectedCountryId)}
                    lockedMessage={"Сначала нужно выбрать страну"}
                    controlRef={controlRefRegion}
                    key={selectedCountryId}
                    label="Регион"
                    widthLimit={450}
                    initSelectedId={selectedRegionId}
                    initRefList={initData?.refs?.regions}
                    apiName2="regions"
                    showIds={true}
                    filterExtraParams={{filter_mode: "regular_only", country_id: selectedCountryId}}
                    onSelect={setSelectedRegionId}
                />}
            </FormBlock>
        </BaseSimpleItemEditorForm>
    );
};

function getInitialCountryId(initData) {
    if (!initData)
        return undefined;

    if (initData.is_region_city)
        return initData.country_id;

    if (initData.region_id === null)
        return null;

    return initData.refs?.regions?.[initData.region_id]?.country_id;
}

export default CitiesItemForm;